<div class="dialog">
  <button
    class="dialog__close"
    app-button
    buttonType="text"
    buttonTheme="light"
    type="button"
    (click)="handleCancelClick()"
    title="Close"
    [attr.aria-label]="'Close'">
    <app-icon icon="times" size="lg"> </app-icon>
  </button>

  <div class="dialog__content flex flex-column items-center justify-center">
    <div class="mb-4 text-24 text-semibold text-center">Your free trial has ended</div>

    <img class="dialog__image" src="assets/images/biodigital-multidevice-graphic.jpg" />

    <button class="mv-4" app-button buttonType="primary" (click)="handleChooseClick()">
      Upgrade Now
    </button>

    <div class="mv-4">
      <app-team-features [label]="upgradeLabel"></app-team-features>
    </div>

    <div class="mt-4 text-14">
      Need more time for evaluation?
      <span role="button" tabindex="0" appSupportLink class="text-underline">Contact us</span>
    </div>
  </div>
</div>
